module.exports = __webpack_public_path__ + "static/media/android.7ee91bb4.svg";